var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSuperAdmin)?_c('order-form',{attrs:{"entity-id":_vm.entityId}}):(_vm.isCompanyAdmin)?_c('company-order-form',{attrs:{"entity-id":_vm.entityId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }